var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14581 9.64619C3.95091 9.84179 3.95147 10.1584 4.14707 10.3533C4.34266 10.5482 4.65922 10.5476 4.85413 10.352L10 5.18752L15.1459 10.352C15.3408 10.5476 15.6573 10.5482 15.8529 10.3533C16.0485 10.1584 16.0491 9.84179 15.8542 9.64618L10.3896 4.16178C10.1746 3.94607 9.82536 3.94607 9.61042 4.16178L4.14581 9.64619ZM4.14581 13.6471C3.95091 13.8427 3.95147 14.1593 4.14707 14.3542C4.34266 14.5491 4.65922 14.5485 4.85413 14.3529L10 9.18842L15.1459 14.3529C15.3408 14.5485 15.6573 14.5491 15.8529 14.3542C16.0485 14.1593 16.0491 13.8427 15.8542 13.6471L10.3896 8.16269C10.1746 7.94698 9.82536 7.94697 9.61042 8.16269L4.14581 13.6471Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.fbad76782bd9eafc8008a18a08daac38.svg";
export { ForwardRef as ReactComponent };